/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prop_StartInputs */

const en_prop_start = /** @type {(inputs: Prop_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start date`)
};

const de_prop_start = /** @type {(inputs: Prop_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdatum`)
};

/**
* | output |
* | --- |
* | "Start date" |
*
* @param {Prop_StartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const prop_start = /** @type {((inputs?: Prop_StartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prop_StartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_prop_start(inputs)
	return en_prop_start(inputs)
});